import {makeAutoObservable} from 'mobx'

export default class StudentRejection {
  id: number

  firstName?: string

  lastName?: string

  indificationNo: string

  passport?: string

  comment?: string

  createdAt?: Date

  startMonth?: number

  startNumericYear?: number

  startHebrewMonthName?: string

  startTextYear?: string

  endMonth?: number

  endNumericYear?: number

  endHebrewMonthName?: string

  endTextYear?: string

  constructor(student: any) {
    this.id = student.Id
    this.firstName = student.FirstName
    this.lastName = student.LastName
    this.indificationNo = student.IndificationNo
    this.passport = student.Passport
    this.comment = student.Comment
    this.createdAt = new Date(student.CreatedAt)
    this.startMonth = student.StartMonth
    this.startNumericYear = student.StartNumericYear ?? student.StartYear
    this.startHebrewMonthName = student.StartHebrewMonthName
    this.startTextYear = student.StartTextYear
    this.endMonth = student.EndMonth
    this.endNumericYear = student.EndNumericYear ?? student.EndYear
    this.endHebrewMonthName = student.EndHebrewMonthName
    this.endTextYear = student.EndTextYear
    makeAutoObservable(this)
  }
}
